import { adminRoles } from "../constants/AdminRoles";

//some constants

export const MaxMessageLength = {
  Unicode: 660,
  SingleByte: 1520,
}

export const getAdminTypeOptions = (isSuperAdmin = false) => {
  const options = [
    { label: "cpaas_admin", value: adminRoles.admin },
    { label: "reseller_admin", value: adminRoles.reseller },
  ]
  if (isSuperAdmin)
    return [
      { label: "super_admin", value: adminRoles.super_admin },
      ...options
    ];
  return options
};

export const adminMfaOptions = [
  { label: "None", value: "NONE" },
  { label: "Rakuten Okta", value: "OKTA" },
];

export const mfaOptions = [
  { label: "None", value: "NONE" },
  // { label: "Google Authenticator", value: "GOOGLE_AUTHENTICATOR" },
];

export const rakutenMfaOptions = [{ label: "Rakuten Okta", value: "OKTA" }];

export const rakutenEnterpriseType = [
  "JAPANESE_RAKUTEN_GROUP",
  "INTERNATIONAL_RAKUTEN_GROUP",
];

export const validRakutenDomains = [
  "rakuten.com", "rakuten-sonpo.co.jp", "rakuten-life.co.jp", "mail.rakuten.com",
];

export const getMfaOption = (enterpriseMFA: string) => {
  if (enterpriseMFA === "NONE") return [mfaOptions[0]];
  else if (enterpriseMFA === "OKTA") return [mfaOptions[1]];
  else return mfaOptions;
};

export const unitsDropdownValues = [
  { unit: "Minutes", unit_jp: "分", validity_period_unit: "minutes", ttl_unit: "minute" },
  { unit: "Hours", unit_jp: "時間", validity_period_unit: "hours", ttl_unit: "hour" },
  { unit: "Days", unit_jp: "日間", validity_period_unit:"days", ttl_unit: "day" },
];

export const getUnitLabelKey = (lang: string) => {
  return lang === "jp" ? "unit_jp" : "unit";
};

export const handleUnitChange = (unit: string) => {
  switch (unit.toLowerCase()) {
    case "minutes":
    case "minute":
    case "分":
      return import.meta.env.VITE_maxInMinutes;
    case "hours":
    case "hour":
    case "時間":
      return import.meta.env.VITE_maxInhours;
    case "days":
    case "day":
    case "日間":
      return import.meta.env.VITE_maxInDays;
    default:
      return "";
  }
}

export const handleUnitDistributionList = (unit: string) => {
  switch (unit.toLowerCase()) {
    case "minutes":
    case "minute":
    case "分":
      return import.meta.env.VITE_maxTTLInMinutes;
    case "hours":
    case "hour":
    case "時間":
      return import.meta.env.VITE_maxTTLInhours;
    case "days":
    case "day":
    case "日間":
      return import.meta.env.VITE_maxTTLInDays;
    default:
      return "";
  }
}

export const handleUnitShortUrl = (unit: string) => {
  switch (unit.toLowerCase()) {
    case "minutes":
    case "minute":
    case "分":
      return {
        maxTTL: import.meta.env.VITE_maxTTLInMinutes,
        minTTL: import.meta.env.VITE_minTTLInMinutes,
      };
    case "hours":
    case "hour":
    case "時間":
      return {
        maxTTL: import.meta.env.VITE_maxTTLInhours,
        minTTL: 1,
      };
    case "days":
    case "day":
    case "日間":
      return {
        maxTTL: import.meta.env.VITE_maxTTLInDays,
        minTTL: 1,
      };
    default:
      return { maxTTL: "", minTTL: "" };
  }
};

export const paymentProfiles = ["PAY_PER_SUBMISSION", "PAY_PER_DELIVERY_ONLY", "PAY_PER_DELIVERY_AND_ACCEPTABLE_FAILURE"]

export const MaskCharacter = (str, startAtIndex, mask = "*") => {
  return str.slice(0, startAtIndex) + str.slice(startAtIndex).replace(/./g, mask);
};

export const WHITELIST = "whitelist";

export const senderIDRestrictionTypeOptions = [
  { label: WHITELIST, value: WHITELIST },
  { label: "allow_all", value: "allow_all_sender_addresses" },
  { label: "allow_alpha", value: "allow_all_alpha_sender_addresses" },
  { label: "allow_numeric", value: "allow_all_numeric_sender_addresses" },
];